import Typography from '@mui/material/Typography';

type Props = {
  searchByFilter?: boolean;
  messageNoRows?: string;
  customMessageNoRows?: string;
};

function DataGridNoRowsOverlay({
  searchByFilter,
  messageNoRows = 'registros',
  customMessageNoRows = undefined
}: Props = {}) {
  return (
    <Typography
      align="center"
      component="div"
      height="100%"
      sx={{
        fontWeight: 'normal',
        color: '#063468',
        fontSize: '14px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
      variant="h4"
      gutterBottom
    >
      {searchByFilter
        ? `No se encontraron resultados.`
        : customMessageNoRows || `${messageNoRows}`}
    </Typography>
  );
}

export default DataGridNoRowsOverlay;
